import { bb } from "$json";
/*
 * grids-to-cards-toggle
 *
 * Allows default tables to behave
 * nicely with given space.
 * Also gives user the functionality
 * to toggle between default table rows
 * and cards format.
 *
 * Author: Tim Bauwens
 * Copyright 2017, 2018 Berkeley Bridge
 *
 * Dependencies: mixins.less
 */

let filter = () => true;

const setFilter = fun => (filter = fun);

export { setFilter };

(function ($, win, doc) {
  var states = {};
  var $controls = "";

  $(doc).on("click", ".bb-p-grid-to-card-toggle", function (e) {
    var modelid, tableid;
    if ($(e.target).data("switch") === "toggle-cards") {
      $(this).attr("data-state", "cards");
      modelid = bb.getVar("modelid");
      tableid = $(this).next('table[data-type="grid"]').attr("id");
      if (typeof states[modelid] === "undefined") {
        states[modelid] = {};
      }
      if (typeof states[modelid][tableid] === "undefined") {
        states[modelid][tableid] = {};
      }
      states[modelid][tableid].state = "cards";
    }
    if ($(e.target).data("switch") === "toggle-grid") {
      $(this).attr("data-state", "grid");
      modelid = bb.getVar("modelid");
      tableid = $(this).next('table[data-type="grid"]').attr("id");
      if (typeof states[modelid] === "undefined") {
        states[modelid] = {};
      }
      if (typeof states[modelid][tableid] === "undefined") {
        states[modelid][tableid] = {};
      }
      states[modelid][tableid].state = "grid";
    }
  });

  $(doc).on("bb:postHandleData", function (event, data) {
    if (data && data.groups && data.groups.length) {
      $('.group.selected table[data-type="grid"]').each(function () {
        if ($(this).prev(".bb-p-grid-to-card-toggle").length !== 0) {
          return;
        } else {
          if (filter(this)) {
            var modelid = bb.getVar("modelid");
            var tableid = $(this).attr("id");
            var state =
              typeof states[modelid] === "undefined"
                ? "grid"
                : typeof states[modelid][tableid] === "undefined"
                  ? "grid"
                  : states[modelid][tableid].state;
            $controls = $(`
                <div data-state="${state}" class="bb-p-grid-to-card-toggle" aria-hidden >
                  <div class="backplate"></div>
                  <button data-switch="toggle-grid" class="bb-p-grid-to-card-toggle-grid"></button>
                  <button data-switch="toggle-cards" class="bb-p-grid-to-card-toggle-card"></button>
                </div>
                `);
            $(this).before($controls);
          }
        }

        let showorhide = mutations => {
          for (let i = 0; i < mutations.length; i++) {
            if (mutations[i].attributeName === "data-visible") {
              $controls.length &&
                $controls.attr(
                  "data-visible",
                  mutations[i].target.getAttribute("data-visible")
                );
            }
          }
        };

        const observer = new MutationObserver(showorhide).observe(this, {
          attributes: true
        });
        showorhide([{ attributeName: "data-visible", target: this }]); // Fake it for the first time.
      });
    }
  });
})(jQuery, window, document);
